import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import UpdateButton from '../what-is-your-situation/UpdateButton'

const Quiz = ({ block }) => {
    const { validateSelection, setValidateSelection, selectedValue, setViewGeneralInformation } =
        useApp()

    const onSubmit = (e) => {
        e.preventDefault()
        setValidateSelection(true)
        setViewGeneralInformation(true)
    }

    const onClickUpdatedSelection = () => {
        setValidateSelection(false)
        setViewGeneralInformation(false)
    }

    const renderSituation = () => {
        if (isEmpty(selectedValue)) {
            return <p>Vous n'avez pas précisé votre situation.</p>
        }

        return selectedValue.map((intitule) => (
            <div className="titled" key={intitule?.IntituleSiSelectionne}>
                {icon('checked')}
                <p>{intitule?.intituleSiSelectionne}</p>
            </div>
        ))
    }

    return (
        <div className="quiz-block">
            <form onSubmit={onSubmit}>
                {!validateSelection ? (
                    <>
                        <h3>
                            {icon('user-search-line')}
                            Quelle est votre situation ?
                        </h3>
                        {block?.childrens && <Parser content_block={block?.childrens} />}
                        <div className="baseocom-quiz-btn-submit">
                            <button type="submit">Afficher les informations</button>
                        </div>
                    </>
                ) : (
                    <div className="selected-title ">
                        <div className="selected-title-container ">
                            <h3>
                                {icon('user-follow-line')}
                                Votre situation ?
                            </h3>
                            <UpdateButton updateFunction={onClickUpdatedSelection} />
                        </div>
                        {renderSituation()}
                    </div>
                )}
            </form>
        </div>
    )
}

export default Quiz
